import { render, staticRenderFns } from "./LittlePreviewFile.vue?vue&type=template&id=5e5f07f3"
import script from "./LittlePreviewFile.vue?vue&type=script&lang=js"
export * from "./LittlePreviewFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports